/* ==========================================================================
   Lin & Lore - PDP redesign gedrag (theme "Ideation", 29-10-2026)

   Laadt na product-page.js en laat dat bestand met rust. Alles hier leest
   de variant die product-page.js al in [data-variant-id-input] zet, en
   werkt daarna de nieuwe onderdelen bij:
     1. voorraadstatus en urgentieblok (echte beschikbaarheid van de variant)
     2. plakkende koopbalk: miniatuur, knoptekst, aantal
     3. mix & match tot 5 items: per extra item eigen kleur en maat
     4. testimonial-kaart: vorige/volgende
     5. trust-balk onder de header: een bericht tegelijk, rustig wisselend
   Geen behavior:'smooth', geen paginascroll (zie lin-lore.js).
   De extra kiezers hebben bewust geen data-option-*-attributen, zodat
   product-page.js ze niet oppakt en de galerij niet verspringt.
   ========================================================================== */
(function () {
  'use strict';

  var section = document.querySelector('[data-product-section]');
  if (!section || section.dataset.llPdpBound) return;
  section.dataset.llPdpBound = 'true';

  var product = null;
  try {
    var node = section.querySelector('[data-product-json]');
    product = node ? JSON.parse(node.textContent) : null;
  } catch (e) {
    product = null;
  }

  var MAX_ITEMS = 5;
  var AU_SIZES = { XS: '6-8', S: '8-10', M: '10-12', L: '12-14', XL: '14-16', '2XL': '16-18', '3XL': '18-20', '4XL': '20-22', '5XL': '22-24' };

  function findVariant(id) {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return null;
  }

  function currentVariant() {
    var input = section.querySelector('[data-variant-id-input]');
    return input ? findVariant(Number(input.value)) : null;
  }

  function isLow(v, threshold) {
    return (
      v.available &&
      v.inventory_management === 'shopify' &&
      v.inventory_policy === 'deny' &&
      typeof v.inventory_quantity === 'number' &&
      v.inventory_quantity > 0 &&
      v.inventory_quantity <= threshold
    );
  }

  function variantLabel(v) {
    return v && v.title !== 'Default Title' ? v.title : (product && product.title) || '';
  }

  /* 1a. Voorraadstatus */
  function updateStock(v) {
    var box = section.querySelector('[data-ll-stock]');
    if (!box || !v) return;
    var txt = box.querySelector('[data-ll-stock-text]');
    var threshold = Number(box.getAttribute('data-low-threshold') || 5);
    var state = 'in_stock';
    var text = box.getAttribute('data-text-in-stock') || 'In stock, ready to ship';

    if (!v.available) {
      state = 'sold_out';
      text = box.getAttribute('data-text-sold-out') || 'Sold out';
    } else if (isLow(v, threshold)) {
      state = 'low';
      text = (box.getAttribute('data-text-low') || 'Only [[count]] left').replace('[[count]]', v.inventory_quantity);
    }

    box.className = box.className.replace(/\bll-stock--[a-z_]+/g, '').trim() + ' ll-stock--' + state;
    if (txt) txt.textContent = text;
  }

  /* 1b. Urgentieblok onder de betaalmethodes */
  function updateUrgency(v) {
    var box = section.querySelector('[data-ll-urgency]');
    if (!box || !v) return;
    var line = box.querySelector('[data-ll-urgency-stock]');
    if (!line) return;
    var threshold = Number(box.getAttribute('data-low-threshold') || 5);
    var key = 'textAvailable';
    if (!v.available) key = 'textSoldOut';
    else if (isLow(v, threshold)) key = 'textLow';
    var text = (box.dataset[key] || '')
      .replace('[[count]]', v.inventory_quantity)
      .replace('[[variant]]', variantLabel(v));
    line.textContent = text;
    line.hidden = text === '';
    line.classList.toggle('is-sold-out', !v.available);
  }

  /* 2. Plakkende koopbalk */
  function sized(src, w) {
    if (!src) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function updateSticky(v) {
    if (!v) return;
    var img = section.querySelector('[data-sticky-thumb]');
    if (img && v.featured_image && v.featured_image.src) {
      var next = sized(v.featured_image.src, 140);
      if (img.getAttribute('src') !== next) img.setAttribute('src', next);
    }
    var submit = section.querySelector('[data-sticky-submit]');
    if (submit) {
      submit.disabled = !v.available;
      var label = submit.querySelector('[data-sticky-label]') || submit;
      label.textContent = v.available
        ? submit.getAttribute('data-label-add') || label.textContent
        : submit.getAttribute('data-label-sold-out') || 'Sold out';
    }
  }

  function sync() {
    var v = currentVariant();
    updateStock(v);
    updateUrgency(v);
    updateSticky(v);
  }

  section.addEventListener('click', function (e) {
    if (e.target.closest('[data-option-button]')) window.setTimeout(sync, 0);
  });
  section.addEventListener('change', function (e) {
    if (e.target.matches('[data-option-select]')) window.setTimeout(sync, 0);
  });

  /* 3. Mix & match tot 5 items */
  var tiersBox = section.querySelector('[data-ll-tiers]');
  var extrasBox = section.querySelector('[data-ll-extras]');
  var inputsBox = section.querySelector('[data-ll-extra-inputs]');
  var qtyInput = section.querySelector('[data-quantity-input]');
  var itemLabel = tiersBox ? tiersBox.getAttribute('data-item-label') || 'Item' : 'Item';
  var soldOutLabel = tiersBox ? tiersBox.getAttribute('data-sold-out-label') || 'Sold out' : 'Sold out';
  var tierCount = 1;

  function optionLabel(value, optionName) {
    if (!/size|maat/i.test(optionName || '')) return value;
    var key = String(value).toUpperCase().trim().replace('XXXXL', '4XL').replace('XXXL', '3XL').replace('XXL', '2XL');
    return AU_SIZES[key] ? value + ' (AU ' + AU_SIZES[key] + ')' : value;
  }

  function variantFor(options) {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var k = 0; k < options.length; k++) {
        if (v.options[k] !== options[k]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function hasAvailable(position, value, chosen) {
    // Is er een beschikbare variant met deze waarde, gegeven de eerdere opties?
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (!v.available || v.options[position] !== value) continue;
      var ok = true;
      for (var k = 0; k < position; k++) {
        if (v.options[k] !== chosen[k]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function firstAvailable() {
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return null;
  }

  function slotChosen(slot) {
    return Array.prototype.map.call(slot.querySelectorAll('[data-ll-slot-option]'), function (s) { return s.value; });
  }

  function refreshSlot(slot) {
    // Zet uitverkochte waarden op disabled en schuif zo nodig door naar een beschikbare.
    var selects = slot.querySelectorAll('[data-ll-slot-option]');
    var chosen = slotChosen(slot);
    for (var p = 0; p < selects.length; p++) {
      var sel = selects[p];
      var firstOk = null;
      for (var o = 0; o < sel.options.length; o++) {
        var opt = sel.options[o];
        var ok = hasAvailable(p, opt.value, chosen);
        opt.disabled = !ok;
        opt.textContent = optionLabel(opt.value, sel.getAttribute('data-option-name')) + (ok ? '' : ' - ' + soldOutLabel);
        if (ok && firstOk === null) firstOk = opt.value;
      }
      if (sel.selectedOptions[0] && sel.selectedOptions[0].disabled && firstOk !== null) {
        sel.value = firstOk;
        chosen[p] = firstOk;
      }
    }
    var v = variantFor(slotChosen(slot));
    slot.setAttribute('data-variant-id', v && v.available ? v.id : '');
    slot.classList.toggle('is-unavailable', !(v && v.available));
  }

  function buildSlot(index, start) {
    var slot = document.createElement('div');
    slot.className = 'll-slot';
    slot.setAttribute('data-ll-slot', '');
    var lab = document.createElement('p');
    lab.className = 'll-slot__label';
    lab.textContent = itemLabel + ' ' + (index + 1);
    slot.appendChild(lab);

    var row = document.createElement('div');
    row.className = 'll-slot__row';
    var onlyDefault = product.variants.length === 1 && product.variants[0].title === 'Default Title';
    if (onlyDefault) {
      var same = document.createElement('p');
      same.className = 'll-slot__same';
      same.textContent = product.title;
      row.appendChild(same);
    } else {
      product.options.forEach(function (name, p) {
        var opt = product.options_with_values ? product.options_with_values[p] : null;
        var values = opt ? opt.values : [];
        if (!values.length) {
          var seen = {};
          product.variants.forEach(function (v) { if (!seen[v.options[p]]) { seen[v.options[p]] = 1; values.push(v.options[p]); } });
        }
        var sel = document.createElement('select');
        sel.className = 'll-slot__select';
        sel.setAttribute('data-ll-slot-option', p);
        sel.setAttribute('data-option-name', typeof name === 'string' ? name : name.name);
        sel.setAttribute('aria-label', itemLabel + ' ' + (index + 1) + ': ' + (typeof name === 'string' ? name : name.name));
        values.forEach(function (val) {
          var o = document.createElement('option');
          o.value = val;
          o.textContent = val;
          sel.appendChild(o);
        });
        if (start) sel.value = start.options[p];
        row.appendChild(sel);
      });
    }
    slot.appendChild(row);
    if (onlyDefault) slot.setAttribute('data-variant-id', product.variants[0].available ? product.variants[0].id : '');
    else refreshSlot(slot);
    return slot;
  }

  function writeInputs() {
    if (!inputsBox) return;
    inputsBox.innerHTML = '';
    var i = 0;
    Array.prototype.forEach.call(extrasBox.querySelectorAll('[data-ll-slot]'), function (slot) {
      var id = slot.getAttribute('data-variant-id');
      if (!id) return;
      var a = document.createElement('input');
      a.type = 'hidden';
      a.name = 'items[' + i + '][id]';
      a.value = id;
      var b = document.createElement('input');
      b.type = 'hidden';
      b.name = 'items[' + i + '][quantity]';
      b.value = '1';
      inputsBox.appendChild(a);
      inputsBox.appendChild(b);
      i++;
    });
  }

  function renderSlots() {
    if (!extrasBox || !product) return;
    var slots = extrasBox.querySelectorAll('[data-ll-slot]');
    var want = Math.max(0, tierCount - 1);
    // Bestaande keuzes blijven staan; alleen bijmaken of weghalen.
    for (var r = slots.length - 1; r >= want; r--) slots[r].remove();
    var start = currentVariant();
    if (!start || !start.available) start = firstAvailable();
    for (var n = slots.length; n < want; n++) extrasBox.appendChild(buildSlot(n + 1, start));
    extrasBox.hidden = want === 0;
    writeInputs();
  }

  function tierPercent(n) {
    var best = 0;
    section.querySelectorAll('[data-ll-tier]').forEach(function (b) {
      var t = Number(b.getAttribute('data-ll-tier'));
      var pct = Number(b.getAttribute('data-ll-tier-pct') || 0);
      if (n >= t && pct > best) best = pct;
    });
    return best;
  }

  function mainQty() {
    return qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1;
  }

  function extraCount() {
    return inputsBox ? inputsBox.querySelectorAll('input[name$="[id]"]').length : 0;
  }

  function updateTierUI() {
    var total = mainQty() + extraCount();
    section.querySelectorAll('[data-ll-sticky-qty]').forEach(function (el) { el.textContent = total; });
    section.querySelectorAll('[data-ll-tier]').forEach(function (b) {
      var on = Number(b.getAttribute('data-ll-tier')) === tierCount;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var saving = section.querySelector('[data-ll-tier-saving]');
    if (saving) {
      var pct = tierPercent(total);
      saving.hidden = pct <= 0;
      if (pct > 0) {
        saving.textContent = (saving.getAttribute('data-template') || '[[pct]]% off applied in your cart')
          .replace('[[pct]]', pct)
          .replace('[[qty]]', total);
      }
    }
  }

  function setTier(n) {
    tierCount = Math.min(MAX_ITEMS, Math.max(1, Math.floor(Number(n) || 1)));
    if (qtyInput) qtyInput.value = 1;
    renderSlots();
    updateTierUI();
  }

  function setMainQty(n) {
    if (qtyInput) qtyInput.value = Math.max(1, Math.floor(Number(n) || 1));
    updateTierUI();
  }

  section.addEventListener('click', function (e) {
    var tier = e.target.closest('[data-ll-tier]');
    if (tier) {
      e.preventDefault();
      setTier(tier.getAttribute('data-ll-tier'));
      return;
    }
    if (e.target.closest('[data-ll-sticky-inc]')) {
      e.preventDefault();
      if (tierCount < MAX_ITEMS && mainQty() === 1) setTier(tierCount + 1);
      else setMainQty(mainQty() + 1);
      return;
    }
    if (e.target.closest('[data-ll-sticky-dec]')) {
      e.preventDefault();
      if (mainQty() > 1) setMainQty(mainQty() - 1);
      else if (tierCount > 1) setTier(tierCount - 1);
    }
  });

  if (extrasBox) {
    extrasBox.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-ll-slot-option]');
      if (!sel) return;
      e.stopPropagation();
      refreshSlot(sel.closest('[data-ll-slot]'));
      writeInputs();
      updateTierUI();
    });
  }

  if (qtyInput) {
    qtyInput.addEventListener('change', function () { setMainQty(qtyInput.value); });
  }

  /* 4. Testimonial-kaart onder het urgentieblok */
  section.querySelectorAll('[data-ll-testimonials]').forEach(function (wrap) {
    var items = Array.prototype.slice.call(wrap.querySelectorAll('[data-ll-testimonial]'));
    var visible = Math.max(1, Number(wrap.getAttribute('data-visible') || 1));
    var isSlider = wrap.getAttribute('data-mode') === 'slider';
    var prev = wrap.querySelector('[data-ll-prev]');
    var next = wrap.querySelector('[data-ll-next]');
    var index = 0;

    function show(n) {
      index = (n + items.length) % items.length;
      items.forEach(function (el, k) {
        var offset = (k - index + items.length) % items.length;
        el.hidden = offset >= visible;
      });
    }

    if (!isSlider || items.length <= visible) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      items.forEach(function (el, k) { el.hidden = isSlider ? k >= visible : k >= visible; });
      return;
    }
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    show(0);
  });

  /* 5. Trust-balk: een bericht tegelijk */
  var trustbar = section.querySelector('[data-ll-trustbar]');
  if (trustbar) {
    var tbSlides = trustbar.querySelectorAll('[data-ll-trustbar-slide]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tbIndex = 0;
    var tbPaused = false;
    if (tbSlides.length > 1 && !reduce) {
      trustbar.addEventListener('mouseenter', function () { tbPaused = true; });
      trustbar.addEventListener('mouseleave', function () { tbPaused = false; });
      window.setInterval(function () {
        if (tbPaused || document.hidden) return;
        tbSlides[tbIndex].classList.remove('is-active');
        tbSlides[tbIndex].setAttribute('aria-hidden', 'true');
        tbIndex = (tbIndex + 1) % tbSlides.length;
        tbSlides[tbIndex].classList.add('is-active');
        tbSlides[tbIndex].removeAttribute('aria-hidden');
      }, 4500);
    }
  }

  sync();
  setTier(1);
})();
